import checkInImg from '../assets/images/checkin.webp';
import exploreImg from '../assets/images/explore-tab.webp';
import toolboxImg from '../assets/images/features_frame.webp';
import lessonsImg from '../assets/images/lessons.webp';
import waterImg from '../assets/images/water-tracker.webp';
import routinesImg from '../assets/images/abtslide_5.webp';

/** Tabbed app screenshots for the homepage “look inside” section. */
export const appShowcaseTabs = [
  {
    id: 'checkin',
    title: 'Daily check-ins',
    body: 'Log mood, energy, stress, and more. Build streaks with gentle accountability.',
    image: checkInImg,
    alt: 'Noor check-in screen with emotional and mood logging',
  },
  {
    id: 'explore',
    title: 'Explore modules',
    body: 'Grounding, anxiety, depression, sleep, movement, and accountability. Pick a path.',
    image: exploreImg,
    alt: 'Noor Explore screen with wellbeing modules',
  },
  {
    id: 'toolbox',
    title: 'Toolbox',
    body: 'Habits, journaling, fitness, sleep sounds, and accountability in one place.',
    image: toolboxImg,
    alt: 'Noor Toolbox with habits, journaling, and fitness tools',
  },
  {
    id: 'lessons',
    title: 'Guided lessons',
    body: 'Structured lesson paths: regulate, notice, reframe, and take one small action.',
    image: lessonsImg,
    alt: 'Noor guided lessons screen',
  },
  {
    id: 'water',
    title: 'Water tracking',
    body: 'Set a daily target, log intake in one tap, and see progress through the day.',
    image: waterImg,
    alt: 'Noor home screen with water intake tracking',
  },
  {
    id: 'routines',
    title: 'Fitness & routines',
    body: 'Browse routines, filter by goal, and follow structured movement plans.',
    image: routinesImg,
    alt: 'Noor explore routines and workout programs',
  },
];
